import { EntityBase } from './EntityBase';
import { RIFMProduct } from './RIFMProduct';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class RIFMProductLicense extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   productLicenseId: number;
   productId: number;
   userId: string;
   licenseAcceptDate: Date;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   rIFMProduct: RIFMProduct;
}

